import { Label } from "@/components/ui/label";

export const selectCls =
  "h-11 w-full rounded-lg border border-input bg-white px-3 text-base text-slate-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]";

export function NativeSelect({ value, onChange, options, placeholder, testid, className = "" }) {
  return (
    <select data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={`${selectCls} ${className}`}>
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map((o) =>
        typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>
      )}
    </select>
  );
}

export function FieldWrap({ label, sub, htmlFor, children, required }) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={htmlFor} className="text-sm font-semibold text-slate-800">
        {label} {required && <span className="text-[hsl(var(--coral))]">*</span>}
      </Label>
      {sub && <p className="-mt-1 text-xs text-slate-500">{sub}</p>}
      {children}
    </div>
  );
}

export function ChoicePills({ value, onChange, options, testid }) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          type="button"
          key={o}
          data-testid={`${testid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          onClick={() => onChange(o)}
          className={`rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${value === o ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-white" : "border-slate-300 bg-white text-slate-700 hover:border-slate-500"}`}
        >
          {o}
        </button>
      ))}
    </div>
  );
}
